import { render } from "./ChromaticKey.vue?vue&type=template&id=26e53ea4&scoped=true"
import script from "./ChromaticKey.vue?vue&type=script&lang=ts"
export * from "./ChromaticKey.vue?vue&type=script&lang=ts"

import "./ChromaticKey.vue?vue&type=style&index=0&id=26e53ea4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-26e53ea4"

export default script